export default "__VITE_ASSET__B1zAA0Rv__"